import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";

export const PartnerLayout = () => {
	return (
		<div className="flex h-screen bg-clyr-gray-900">
			<Sidebar />
			<main className="flex-1 overflow-auto p-6">
				<Outlet />
			</main>
		</div>
	);
};
